import { isRowSent } from '@features/buyer-line-items-pagination/utils/is-row-sent';
import { originalItemsById } from '@features/buyer-line-items-pagination/utils/original-items-by-id';
import type { LineItem, Lot, LotChanges } from 'types';

export interface IsPagingLockedParams {
  lotChanges?: LotChanges;
  originalItemsById: Map<string, LineItem>;
}

export const isPagingLocked = ({ lotChanges, originalItemsById: items }: IsPagingLockedParams): boolean => (
  Object.keys(lotChanges?.line_items ?? {})
    .some(lineItemId => isRowSent({ lineItemId, lotChanges, originalItemsById: items }))
);

export const isLotPagingLocked = ({ lotChanges, originalLot }: { lotChanges?: LotChanges; originalLot?: Lot }): boolean => (
  isPagingLocked({ lotChanges, originalItemsById: originalItemsById(originalLot) })
);
